import pathOr from 'ramda/es/pathOr';
import {RootState} from '@shared/types/rootState';
import {API, DATA} from '../constants';

export default <T>(
    key: string,
    defaultValue?: T,
    extraPath?: string[] | string
  ) =>
  (state: RootState): T | null => {
    const data =
      pathOr(
        defaultValue || null,
        [API, key, DATA].concat(extraPath || [])
      )(state) || null;
    // Some APIs return null on e.g. ontology errors which result in a empty string
    return data === '' ? defaultValue || null : data;
  };
